import { DataGrid } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDataSource } from "../../../../contexts/dataSource";
import { useAuth } from "../../../../contexts/auth";
import { getPropsDataGrid, getPropsDataGridColSpan, getPropsDataGridEditing, getPropsDataGridPopup, getPropsDateEdit, getPropsLookupExprForIdText }
    from "../../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup } from "devextreme-react/data-grid";
import { useLookupGroup } from "../../../../contexts/lookup-group-context";
import { lookupGroups } from "../../../../utils/lookup-groups.ts";


function School({ employeeId }) {

    const { dataSourceHR } = useDataSource()
    const { user, activeLanguage } = useAuth()
    const { getLookupData } = useLookupGroup()
    const [graduationStatusList, setGraduationStatusList] = useState()
    const [schoolTypeList, setSchoolTypeList] = useState()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeSchool/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeSchool/FormData"
    }), [user, employeeId])

    const handleInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
    }, [employeeId])

    useEffect(() => {
        getLookupData(lookupGroups.graduationStatus).then(response => setGraduationStatusList(response))
        getLookupData(lookupGroups.schoolType).then(response => setSchoolTypeList(response))
    }, [activeLanguage])

    return (
        <React.Fragment>
            <DataGrid
                dataSource={employeeId ? dataSource : undefined}
                {...getPropsDataGrid}
                onInitNewRow={handleInitNewRow}
            >
                <Editing {...getPropsDataGridEditing}>
                    <Popup {...getPropsDataGridPopup} />
                </Editing>
                <Column dataField="name" caption="Okul Adı" >
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="schoolTypeId" caption="Okul Türü">
                    <Lookup dataSource={schoolTypeList} {...getPropsLookupExprForIdText} />
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="department" caption="Bölümü" >
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="graduationStatusId" caption="Mezuniyet Durumu">
                    <Lookup dataSource={graduationStatusList} {...getPropsLookupExprForIdText} />
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="graduationDate" caption="Mezyniyet Tarihi" {...getPropsDateEdit}>
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="diplomaNumber" caption="Diploma Numarası" >
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="gpa" caption="Not Ortalaması">
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
            </DataGrid>
        </React.Fragment>
    )
}

export default School